module.exports = __webpack_public_path__ + "static/media/spoonerism-task (8).e3e33572.mp3";